/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_SettingsInputs */

const en_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Settings`)
};

const fr_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres du projet`)
};

const de_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekteinstellungen`)
};

const it_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni del progetto`)
};

const ru_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки проекта`)
};

const es_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración del proyecto`)
};

const zh_cn2_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目设置`)
};

const ja_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト設定`)
};

const hi_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सेटिंग्स`)
};

const pt_pt2_project_settings = /** @type {(inputs: Project_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações do projeto`)
};

/**
* | output |
* | --- |
* | "Project Settings" |
*
* @param {Project_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_settings = /** @type {((inputs?: Project_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_settings(inputs)
	if (locale === "de") return de_project_settings(inputs)
	if (locale === "it") return it_project_settings(inputs)
	if (locale === "ru") return ru_project_settings(inputs)
	if (locale === "es") return es_project_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_project_settings(inputs)
	if (locale === "ja") return ja_project_settings(inputs)
	if (locale === "hi") return hi_project_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_project_settings(inputs)
	return en_project_settings(inputs)
});